var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_vm._m(0),_c('div',{staticClass:"J-weixin-tip-img weixin-tip-img"}),_c('div',{staticClass:"w-full flex flex-col items-center py-4"},[_c('Button',{staticClass:"my-2",attrs:{"type":"info"},on:{"click":function($event){_vm.$route.query.afterRoute
          ? _vm.$router.replace({
              name: _vm.$route.query.afterRoute,
            })
          : _vm.$router.replace({
              path: '/mine/order',
              query: { active: 2, backRoute: 'Mine' },
            })}}},[_vm._v("我已完成支付")]),_c('Button',{staticClass:"my-2",attrs:{"plain":"","type":"info"},on:{"click":function($event){_vm.$route.query.afterRoute
          ? _vm.$router.replace({
              name: _vm.$route.query.afterRoute,
            })
          : _vm.$router.replace({
              path: '/mine/order',
              query: { active: 1, backRoute: 'Mine' },
            })}}},[_vm._v("支付遇到问题")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"J-weixin-tip weixin-tip"},[_c('div',{staticClass:"weixin-tip-content"},[_vm._v(" 请在菜单中选择在浏览器中打开,"),_c('br'),_vm._v(" 以完成支付 ")])])}]

export { render, staticRenderFns }